import './App.css';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import {UserContextProvider} from './context/userContext/userContext'
import PrivateRoutes from './routes/PrivateRoutes';
import axios from 'axios'
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import {Toaster} from 'react-hot-toast'
import Home from './pages/Home/Home';
import Register from './pages/Register/Register';
import Terms from './pages/Terms/Terms';
import Plugins from './pages/Plugins/Plugins'
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy'
import { StyleProvider } from './context/styleContext/styleContext'
import { ShoppingCartProvider } from './context/shoppingCartContext/shoppingCartContext';
import Login from './pages/Login/Login';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import FAQ from './pages/FAQ/FAQ';
import Support from './pages/Support/Support';
import Account from './pages/Account/Account';
import CreateLicense from './components/CreateLicense/CreateLicense';
import InfinityReverb from './pages/InfinityReverb/InfinityReverb';
import PageAnalytics from './DataCollection/PageAnalytics';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import CookieHandler from './components/CookieHandler/CookieHandler';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import ProductPage from './pages/Product/ProductPage';
import ProductReviewPage from './pages/Product/ProductReviewPage';
import Admin from './pages/Admin/Admin';
import AdminRoutes from './routes/AdminRoutes';
import ShoppingCart from './pages/ShoppingCart/ShoppingCart';
import MyGear from './pages/myGear/MyGear';
import CheckoutPage from './pages/Checkout/CheckoutPage';
import GainDemo from './pages/GainDemo/GainDemo';
import ReverbLearning from './pages/Learning/Reverb';
import DelayLearning from './pages/Learning/Delay';
import Learning from './pages/Learning/Learning';
import CompressionLearning from './pages/Learning/Compression';
import ChorusLearning from './pages/Learning/Chorus';
import OverdriveLearning from './pages/Learning/Overdrive';
import EQLearning from './pages/Learning/EQ';
import SubConfirmPage from './pages/Subscription/SubConfirmPage';
import ManageSubscription from './pages/Subscription/ManageSubscription';
import DistortionLearning from './pages/Learning/Distortion';
import AllReleases from './pages/AllReleases/AllReleases';
import CompareDistOdFuzz from './pages/Learning/CompareDistOdFuzz';
import ImageRendering from './pages/Admin/ImageRendering'



if(process.env.NODE_ENV === 'development')
{
   //axios.defaults.baseURL = 'http://localhost:8080';
  axios.defaults.baseURL = 'https://api.parishaudio.com/'
}
else
{
  axios.defaults.baseURL = 'https://api.parishaudio.com/'
}


axios.defaults.withCredentials = true;



function App() {
  return (
    
    <BrowserRouter>
    <UserContextProvider>
    {/* <PageAnalytics endpoint={axios.defaults.baseURL + '/record-page-analytics'}> */}
    <StyleProvider>
    <ShoppingCartProvider>
    <CookieHandler />
    <Header />
    <Toaster position='bottom-right' toastOptions={{
    // Global default styles
    duration:3000,
    style: {
      borderRadius: '8px',
      background: '#1f2937', // Dark background
      color: '#f9fafb',       // Light text
      padding: '12px 16px',
      fontSize: '1.3rem',
    },
    success: {
      iconTheme: {
        primary: '#10b981', // Tailwind Emerald-500
        secondary: '#d1fae5',
      },
    },
    error: {
      iconTheme: {
        primary: '#ef4444', // Tailwind Red-500
        secondary: '#fee2e2',
      },
    },
  }} />



      <Routes>

      


      <Route element= {<PrivateRoutes />}>

        <Route path="account" element={<Account/>} />
        <Route path="/my-gear" element={<MyGear />} />
        <Route path="/checkout" element= {<CheckoutPage />} />
        <Route path="/manage-subscriptions" element = {<ManageSubscription />} />
        <Route path="/subscription-confirmation" element = {<SubConfirmPage />} />

        {/* <Route path='/account' element={<Account />} />
        <Route path='/my-gear' element={<MyGear />} />
        <Route path= '/checkout' element = {<CheckoutPage />} />
        <Route path= '/subscription-confirmation' element = {<SubConfirmPage />} /> */}

      </Route>


        <Route element={<AdminRoutes />}>
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/create-license" element={<CreateLicense />} />
          <Route path="/gain-demo" element={<GainDemo />} />
          <Route path="/admin/image-rendering" element = {<ImageRendering />} />
        </Route>



        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/all-releases" element={<AllReleases />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/home" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/support" element={<Support />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/plugins" element={<Plugins />} />
        <Route path="/register" element={<Register />} />
        <Route path="/shopping-cart" element={<ShoppingCart />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path='/reset-password/:token' element = {<ResetPassword/>} />
        <Route path="/learning" element={<Learning />} />
        <Route path="/learning/chorus" element={<ChorusLearning />} />
        <Route path="/learning/compare-distortion-overdrive-fuzz" element={<CompareDistOdFuzz />} />
        <Route path="/learning/compression" element={<CompressionLearning />} />
        <Route path="/learning/delay" element={<DelayLearning />} />
        <Route path="/learning/distortion" element={<DistortionLearning />} /> 
        <Route path="/learning/equalization" element={<EQLearning />} />
        <Route path="/learning/overdrive" element={<OverdriveLearning />} />
        <Route path="/learning/reverb" element={<ReverbLearning />} />
        <Route path="/login" element={<Login />} />
        <Route path="/products/:sku" element={<ProductPage />} />
        <Route path='/reviews/:itemName' element={<ProductReviewPage />} />
        
      </Routes>
      <Footer />

      </ShoppingCartProvider>
      </StyleProvider>
      {/* </PageAnalytics> */}
      </UserContextProvider>
    </BrowserRouter>
  );
}

export default App;

